<ion-header>
  <ion-toolbar>
    <ion-title>Join Team</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="cancel()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="card-wrapper">
    <!-- your existing template here -->

    <ion-avatar class="team-avatar" *ngIf="teamLogo">
      <img [src]="teamLogo" />
    </ion-avatar>

    <ng-container *ngIf="!loading; else loadingSpinner">
      <h2>Do you want to join <b>{{ teamName }}</b>?</h2>

      <ion-button expand="block" color="primary" (click)="joinTeam()">
        Join Team
      </ion-button>

      <ion-button expand="block" color="medium" fill="outline" (click)="cancel()">
        Cancel
      </ion-button>
    </ng-container>

    <ng-template #loadingSpinner>
      <ion-spinner name="crescent"></ion-spinner>
    </ng-template>
  </div>
</ion-content>